import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { PermissionSteps } from './PermissionSteps';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
}

export const SliderModal:React.FC<IProps> = ({ isOpen, onClose, onRetry }) => {
  const topRef = useRef<HTMLDivElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);
  const observer = useRef<IntersectionObserver>(new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) onClose();
  }, { threshold: 1 }));

  useEffect(() => {
    if (topRef.current && bottomRef.current) {
      bottomRef.current.scrollIntoView();
      observer.current.observe(topRef.current);
    }

    return () => observer.current.disconnect();
  }, []);

  useEffect(() => {
    if (isOpen) bottomRef.current?.scrollIntoView();
  }, [isOpen]);

  const modalClassNames = classNames({
    'myinterview-widget-slider-modal': true,
    'myinterview-widget-slider-modal--open': isOpen,
  });

  return (
    <div className={modalClassNames}>
      <div className="myinterview-widget-slider-modal__wrapper">
        <div ref={topRef} className="myinterview-widget-slider-modal__top" />
        <div ref={bottomRef} className="myinterview-widget-slider-modal__bottom">
          <span className="myinterview-widget-slider-modal__pill" />
          <PermissionSteps onRetry={onRetry} />
        </div>
      </div>
    </div>
  );
};
